module.exports = __webpack_public_path__ + "img/2.879c625d.jpg";